import { Helmet } from 'react-helmet-async'
import { toast } from 'react-toastify'

// @ts-expect-error TS7016
import { NewArtwork } from '@domain-group/artwork-builder'
import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { buildEditArtworkUrl } from '@hooks/useArtworkBuilderPaths'

import type { SavedArtworkPageModel, TemplatePageModel } from '@models/types'

import useArtworkBuilder from '../../hooks/useArtworkBuilder'

type QueryParams = {
  campaignQuoteItemId?: string,
  orderItemId?: string,
  redirect?: string,
}

type SelectTemplatePageParams = {
  createFn: (templatePage: TemplatePageModel, options: object) => Promise<object>,
  options: object,
  redirect?: string,
  templatePage: TemplatePageModel,
}

type SelectSavedArtworkParams = {
  createFn: (savedArtwork: object) => Promise<object>,
  redirect?: string,
  savedArtwork: SavedArtworkPageModel,
}

const selectSavedArtworkPage = (params: SelectSavedArtworkParams) => {
  const { createFn, redirect, savedArtwork } = params

  createFn(savedArtwork).then((response) => {
    // @ts-expect-error TS2339
    const { success, data, errors = [] } = response
    if (!success){
      toast.warn(errors[0])
      return
    }

    const editArtworkUrl = buildEditArtworkUrl({ artwork: data, redirectUrl: encodeURIComponent(redirect || '') })

    if (editArtworkUrl){
      window.location.href = editArtworkUrl
    }
  })
}

const selectTemplatePage = (params: SelectTemplatePageParams) => {
  const {
    createFn,
    options,
    redirect,
    templatePage,
  } = params

  createFn(templatePage, options).then((response) => {
    // @ts-expect-error TS2339
    const { success, data, errors = [] } = response
    if (!success){
      toast.warn(errors[0])
      return
    }

    const editArtworkUrl = buildEditArtworkUrl({ artwork: data, redirectUrl: encodeURIComponent(redirect || '') })

    if (editArtworkUrl){
      window.location.href = editArtworkUrl
    }
  })
}

const NewPage = () => {
  const queryParams: QueryParams = parsePermittedQueryParams(getQueryParamsFromHash(), [
    'campaignQuoteItemId',
    'orderItemId',
    'redirect',
  ])

  const { campaignQuoteItemId, orderItemId, redirect } = queryParams

  // @ts-expect-error TS2322
  const artworkBuilderPayload = useArtworkBuilder({ campaignQuoteItemId, orderItemId, redirect })
  const {
    callbacks: {
      fetchNewArtworkOptions,
      goBack,
    },
  } = artworkBuilderPayload

  return (
    <>
      <Helmet>
        <title>Artwork Builder | Realhub</title>
      </Helmet>

      <NewArtwork
        callbacks={{
          artworkUploadSuccess: () => goBack(),
          closeSelectTemplateModal: () => goBack(),
          fetchEditorOptions: fetchNewArtworkOptions,
          // @ts-expect-error TS7006
          selectSavedArtwork: (savedArtwork, createFn) => selectSavedArtworkPage({
            createFn,
            redirect,
            savedArtwork,
          }),
          // @ts-expect-error TS7006
          selectTemplatePage: (templatePage, createFn, _, options) => selectTemplatePage({
            createFn,
            options,
            redirect,
            templatePage,
          }),
        }}
      />
    </>
  )
}

export default NewPage
